import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import axios from "axios";

export default function GooglePlacesAutocomplete({
  countries = "au" || [],
  languageCode = "en",
  formatted_address,
  handleAddressComponentsValue,
  api_key,
}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState(null);

  React.useEffect(() => {
    setSearch(formatted_address);
  }, [formatted_address]);

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      const context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(context, args), delay);
    };
  }
  const handleOpen = (value) => {
    if (!value) return setOptions((prev) => prev);
    setOpen(true);
    (async () => {
      setLoading(true);

      let data = JSON.stringify({
        input: value,
        includedRegionCodes: countries,
        languageCode,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `https://places.googleapis.com/v1/places:autocomplete`,
        headers: {
          "X-Goog-Api-Key": api_key,
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          setOptions(response.data?.suggestions || []);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    })();
  };
  const debouncedHandleOpen = debounce((value) => {
    handleOpen(value);
  }, 50);

  const handleClose = () => {
    setOpen(false);
    setOptions([]);
  };

  return (
    <>
      <Autocomplete
        size="small"
        fullWidth
        open={open}
        onOpen={() => handleOpen(search)}
        onClose={handleClose}
        onChange={(e, value) => {
          if (!value) return null;
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://places.googleapis.com/v1/places/${value.placePrediction.placeId}?languageCode=${languageCode}`,
            headers: {
              "X-Goog-FieldMask": "*",
              "X-Goog-Api-Key": api_key,
            },
          };

          axios
            .request(config)
            .then((response) => {
              const values = {};

              response.data.addressComponents?.forEach((address_component) => {
                address_component.types.forEach((type) => {
                  if (type !== "political") {
                    values[type] = {
                      long_name: address_component.longText,
                      short_name: address_component.shortText,
                    };
                  }
                });
              });

              values.location = {
                latitude: response.data.location.latitude,
                longitude: response.data.location.longitude,
              };
              values.formatted_address = {
                long_name: response.data.formattedAddress,
              };

              

              handleAddressComponentsValue({
                componentValues: values,
                formatted_address: response.data.formattedAddress,
              });
              setSearch(response.data.formattedAddress);
            })
            .catch((error) => {});
        }}
        // isOptionEqualToValue={(option, value) =>
        //   option?.placePrediction?.placeId === value?.placePrediction?.placeId
        // }
        autoComplete
        filterOptions={(x) => x}
        inputValue={search ?? formatted_address}
        getOptionLabel={(option) => {
          return option?.placePrediction?.text?.text
            ? option?.placePrediction?.text?.text
            : null;
        }}
        options={options}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Place"
            value={search ?? formatted_address}
            onChange={(e) => {
              setSearch(e.target.value); // Update the input value
              handleOpen(e.target.value); // Call the debounced function
            }}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
      />
    </>
  );
}
